export default "__VITE_ASSET__9bcbf9df__"